module.exports = __webpack_public_path__ + "img/42_BF20_go_feral.c9ba229e.jpg";